'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'swords-laser';
var width = 640;
var height = 512;
var ligatures = [];
var unicode = 'e03d';
var svgPathData = ['M255.99976,313.1994l42.69531-46.67959-42.69531-46.48818ZM135.031,7.03013a24.01075,24.01075,0,0,0-.64063,33.287l225.66406,245.7026V182.49655L168.32007,6.38951A24.0151,24.0151,0,0,0,135.031,7.03013Zm369.9375-.00195a24.00147,24.00147,0,0,0-33.27344-.64062L343.656,123.985l37.8125,34.72844a47.92694,47.92694,0,0,1,18.71093-3.78124c.1836,0,.35547.05078.53907.05273L505.60913,40.3074A24.00108,24.00108,0,0,0,504.96851,7.02818Z', 'M196.60132,224.62928l-28.76563,29.11321a32.00691,32.00691,0,0,0-45.27734,45.25186L9.33569,412.15427a32.06984,32.06984,0,0,0,.01172,45.2499L54.656,502.64235a32.01846,32.01846,0,0,0,45.25-.00976L219.26538,384.25784a15.98659,15.98659,0,0,0,4.73438-11.3574v-137.029C223.99976,221.56678,206.656,214.45156,196.60132,224.62928Zm-28.0625,135.81806a16,16,0,1,1,16.00781-16A16.00493,16.00493,0,0,1,168.53882,360.44734ZM545.781,327.24429l-22.63282,22.63862L630.6521,457.3905l.00391-.002a32.0876,32.0876,0,0,0,.00781-45.26162ZM411.43726,191.70552c-10.0625-10.15623-27.375-3.0332-27.375,11.26169V339.963a16.01218,16.01218,0,0,0,4.6875,11.31834l55.1875,55.17762,90.53125-90.53106Zm43.8164,226.06983,84.8711,84.85333a31.9925,31.9925,0,0,0,45.23437.00977l.00391-.00586L477.87866,395.1504Zm33.94141-33.94329L596.68335,491.324l22.64453-22.623-107.5-107.50172Z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faSwordsLaser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;